
export class VersionedResourceId {
    readonly id: string;
    readonly version: number;

    constructor(id: string, version: number) {
        if (id == null)
            throw new Error('null id');
        if (version == null)
            throw new Error('null version');
        this.id = id;
        this.version = version;
    }

    toString(): string {
        return this.id + ':' + this.version;
    }

    toJSON(): string {
        return this.toString();
    }
}

export interface VersionableResourceById {

    getVersionId(): VersionedResourceId;

}
